import React, { FC } from "react";

import { Button, Form, Modal } from "react-bootstrap";

import styles from "./ByPassHoldModal.module.scss";

interface ByPassHoldModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (choice: "yes" | "no") => void;
}

const ByPassHoldModal: FC<ByPassHoldModalProps> = ({ show, onHide, onSubmit }) => {
  const [selectedChoice, setSelectedChoice] = React.useState<"yes" | "no" | null>(null);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedChoice(event.target.value as "yes" | "no");
  };

  const handleFormSubmit = () => {
    if (selectedChoice) {
      onSubmit(selectedChoice);
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <div className={styles.modalContainer}>
        <button className={styles.modalCloseButton} onClick={onHide}>
          ✕
        </button>
        <h4 className="mb-4">Do you want to bypass the hold period?</h4>
        <p>By selecting yes you will bypass the 21-day hold period.</p>
        <p>The artist will still receive an email that their work has been identified in a resale.</p>
        <Form>
          <div className={styles.radioGroup}>
            <Form.Check
              type="radio"
              id="choice-yes"
              label="Yes"
              value="yes"
              name="choice"
              className={styles.radioOption}
              onChange={handleOptionChange}
            />
            <Form.Check
              type="radio"
              id="choice-no"
              label="No"
              value="no"
              name="choice"
              className={styles.radioOption}
              onChange={handleOptionChange}
            />
            <Button className={styles.actionButton} onClick={handleFormSubmit} disabled={!selectedChoice}>
              Next
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default ByPassHoldModal;
